<nav *ngIf="breadcrumbs.length" aria-label="breadcrumb">
  <ul class="breadcrumb">
    <li class="breadcrumb-element">
      <a routerLink="/main" class="breadcrumb-link">Inicio</a>
    </li>

    <li *ngFor="let crumb of breadcrumbs; let last = last" class="breadcrumb-element">
      <span class="separator">/</span>
      <ng-container *ngIf="!last">
        <ng-container *ngIf="crumb.url != null && crumb.url !== '' && crumb.url !== '/undefined'">
          <a class="breadcrumb-link" [routerLink]="crumb.url.toString()">
            {{crumb.label }}</a>
        </ng-container>
        <ng-container *ngIf="crumb.url == null || crumb.url === '' || crumb.url === '/undefined'">
          <span class="breadcrumb-link">{{ crumb.label }}</span>
        </ng-container>
      </ng-container>


      <ng-container *ngIf="last">
        <span class="breadcrumb-active">{{ crumb.label }}</span>
      </ng-container>
    </li>
  </ul>
</nav>